const BEE2LINK = 'BEE2LINK';
const IMAGE_INSIDE_360 = 'IMAGE_INSIDE_360';
export const BODYWORK_APPOINTMENT = 'BODYWORK_APPOINTMENT';
export const CAR_CONFIGURATOR = 'CAR_CONFIGURATOR';
export const CLIPPING = 'CLIPPING';
export const LEAD = 'LEAD';
export const LOCKER_BOOKING = 'LOCKER_BOOKING';
export const MOBILITY = 'MOBILITY';
export const PROACTIVE = 'PROACTIVE';
export const MULTIPLE_PAYERS = 'MULTIPLE_PAYERS';
export const ONLINE_PAYMENT = 'ONLINE_PAYMENT';
const OPEN_FLEX = 'OPEN_FLEX';
const PLANET_VO = 'PLANET_VO';
export const PARTS_REMINDER = 'PARTS_REMINDER';
export const REMINDER = 'REMINDER';
export const SELF_SERVICE_CHECK_IN_DOCUMENTS = 'SELF_SERVICE_CHECK_IN_DOCUMENTS';
export const SELF_SERVICE_CHECK_OUT_DOCUMENTS = 'SELF_SERVICE_CHECK_OUT_DOCUMENTS';
export const SELF_SERVICE_EXTRAS = 'SELF_SERVICE_EXTRAS';
export const SELF_SERVICE_QUESTIONS = 'SELF_SERVICE_QUESTIONS';
const VIDEO_360 = 'VIDEO_360';
export const WHITE_LISTED_PLATES = 'WHITE_LISTED_PLATES';

export const TAGS_SALES = 'TAGS_SALES';
export const TAGS_PARTS = 'TAGS_PARTS';
export const TAGS_AFTERSALES = 'TAGS_AFTER_SALES';

export const FEATURES = {
  BEE2LINK,
  BODYWORK_APPOINTMENT,
  CAR_CONFIGURATOR,
  IMAGE_INSIDE_360,
  LEAD,
  LOCKER_BOOKING,
  MULTIPLE_PAYERS,
  ONLINE_PAYMENT,
  OPEN_FLEX,
  PARTS_REMINDER,
  PLANET_VO,
  REMINDER,
  MOBILITY,
  PROACTIVE,
  SELF_SERVICE_CHECK_IN_DOCUMENTS,
  SELF_SERVICE_CHECK_OUT_DOCUMENTS,
  SELF_SERVICE_EXTRAS,
  SELF_SERVICE_QUESTIONS,
  VIDEO_360,
  TAGS_SALES,
  TAGS_PARTS,
  TAGS_AFTERSALES,
  CLIPPING,
  WHITE_LISTED_PLATES
};
